import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './pages/Home/Home';
import Endereco from './pages/Endereco/Endereco';
import Simulacao from './pages/Simulacao/Simulacao';
import Contato from './pages/Contato/Contato';
import Informacoes from './pages/Informacoes/Informacoes';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/"          element={<Home />} />
          <Route path="/endereco"  element={<Endereco />} />
          <Route path="/simulacao" element={<Simulacao />} />
          <Route path="/contato"   element={<Contato />} />
          <Route path="/informacoes" element={<Informacoes />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
